import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router  } from '@angular/router';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private authService: AuthService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authService.isAuthenticated()) {
          return true;
        } else {
          this.router.navigate(['/signin']);
        }
        return false;
    }
}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/auth/auth-guard.service.ts